// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const Facebook: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32">
            <g fill="none" fillRule="evenodd">
                <rect width="31" height="31" x=".5" y=".5" stroke="currentColor" rx="2" />
                <path
                    fill="currentColor"
                    fillRule="nonzero"
                    d="m20.634 17.611.553-3.378H17.73V12.04c0-.925.483-1.825 2.032-1.825h1.572V7.339s-1.426-.228-2.79-.228c-2.849 0-4.71 1.618-4.71 4.547v2.575h-3.166v3.378h3.166v8.167h3.896V17.61h2.905Z"
                />
            </g>
        </svg>
    );
};

export default React.memo(Facebook);
